import { useContext, useEffect, useState } from "react";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Modal from 'react-modal';
import Select from 'react-select';
import 'react-toggle/style.css';
import Swal from "sweetalert2";
import { refeshPend } from "../../../App";
import { getApi, postApi } from "../../Admin Master/Area Control/Zonemaster/ServicesApi";


function CreateDrs() {
    const { refFun, ref } = useContext(refeshPend)
    const [getData, setGetData] = useState([]);
    const [empData, setEmpData] = useState([]);
    const [getCity, setGetCity] = useState([]);
    const [vehicleData, setVehicleData] = useState([]);
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const [fromDateM, setFromDateM] = useState(firstDayOfMonth);
    const [toDateM, setToDateM] = useState(today);
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectAll, setSelectAll] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedManifestRows, setSelectedManifestRows] = useState([]);
    const [selectedDocketNos, setSelectedDocketNos] = useState([]);
    const [docket, setDocket] = useState('');
    const [formData, setFormData] = useState({
        DocketNo: [],
        vehicleNo: "",
        empName: "",
        cityName: "",
        mobileNo: "",
        drsDate: today,
    })
    console.log(formData);
    const handleDateChange = (date, field) => {
        setFormData({ ...formData, [field]: date });
    };
    const fetchData = async (endpoint, setData) => {
        try {
            const response = await getApi(endpoint);
            setData(Array.isArray(response.Data) ? response.Data : []);
        } catch (err) {
            console.error('Fetch Error:', err);
        } finally {
            setLoading(false);
        }
    };

    const fetchEmpData = async () => {
        try {
            const response = await getApi(`/Master/GetEmployee?Branch_Code=${JSON.parse(localStorage.getItem('Login'))?.Branch_Code}`);
            setEmpData(Array.isArray(response.Data) ? response.Data : []);
        } catch (err) {
            console.error('Fetch Error:', err);

        }
    };
    useEffect(() => {
        fetchData('/Master/VehicleMaster', setVehicleData);
        fetchEmpData();
        fetchData('/Master/getdomestic', setGetCity);
    }, [])





    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            const login = JSON.parse(localStorage.getItem("Login"));
            const formatDate = (date) => {
                const d = new Date(date);
                return d.toISOString().split("T")[0]; // ✅ SAFE
            };
            try {
                const response = await getApi(`/Runsheet/getPendingRunsheet?sessionLocationCode=${JSON.parse(localStorage.getItem("Login"))?.Branch_Code}&DocketNo=${searchQuery}&pageNumber=${currentPage}&pageSize=${rowsPerPage}&FromDate=${formatDate(fromDateM)}&ToDate=${formatDate(toDateM)}`);
                const currentPageData = Array.isArray(response.data) ? response.data : [];
                setGetData(currentPageData);
                setTotalRecords(response?.count);
            } catch (error) {
                console.error("Error fetching data:", error);
                setGetData([])
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [currentPage, rowsPerPage, fromDateM, toDateM, searchQuery]);


    const totalPages = Math.ceil(totalRecords / rowsPerPage);

    const handlePreviousPage = () => currentPage > 1 && setCurrentPage(currentPage - 1);
    const handleNextPage = () => currentPage < totalPages && setCurrentPage(currentPage + 1);

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };


    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1);
    };

    const handleSelectAll = () => {
        const newState = !selectAll;
        setSelectAll(newState);

        if (newState) {
            // Select All
            setSelectedRows(getData.map((_, index) => index));                    // row index array
            setSelectedDocketNos(getData.map(m => m.DocketNo));                   // all docket numbers
            setSelectedManifestRows([...getData]);                                // entire row data
        } else {
            // Unselect All
            setSelectedRows([]);
            setSelectedDocketNos([]);
            setSelectedManifestRows([]);
        }
    };;

    const handleRowSelect = (index, docketNo, n) => {
        const already = selectedRows.includes(index);
        const updatedRows = already ? selectedRows.filter(i => i !== index) : [...selectedRows, index];
        if (already) {
            setSelectedDocketNos(selectedDocketNos.filter(docket => docket !== docketNo));
            setSelectedManifestRows(selectedManifestRows.filter(row => row.DocketNo !== docketNo));
        } else {
            setSelectedDocketNos([...selectedDocketNos, docketNo]);
            setSelectedManifestRows([
                ...selectedManifestRows,
                getData.find(manifest => manifest.DocketNo === docketNo)
            ]);
        }
        setSelectedRows(updatedRows);
        setSelectAll(updatedRows.length === n);
    };
    const loginBranch = JSON.parse(localStorage.getItem("Login"))?.Branch_Code || "";

    const handleDocketNoSelect = () => {
        setFormData((prevData) => ({
            ...prevData,
            DocketNo: selectedDocketNos,
        }));
        setModalIsOpen(false);
    };
    const formatDate = (date) => {
        if (!date) return null;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${day}/${month}/${year}`;
    };

    const handleFind = () => {
        // Clean scanner value
        const doc = String(docket)
            .trim()
            .replace(/\r|\n/g, "");

        if (!doc) {
            Swal.fire({
                icon: "warning",
                title: "Empty",
                text: "Enter docket number!"
            });
            return;
        }

        // Find docket
        const found = getData.find(
            m => String(m.DocketNo).trim() === doc
        );

        if (!found) {
            Swal.fire({
                icon: "error",
                title: "Not Found!",
                text: `Docket No ${doc} not exists in Manifest List`
            });
            setDocket("");
            return;
        }

        // Duplicate check
        if (selectedDocketNos.includes(doc)) {
            Swal.fire({
                icon: "warning",
                title: "Already Selected",
                text: `Docket No ${doc} already added`
            });
            setDocket("");
            return;
        }

        // Add selected data
        setSelectedDocketNos(prev => [...prev, doc]);
        setSelectedManifestRows(prev => [...prev, found]);

        const index = getData.findIndex(
            m => String(m.DocketNo).trim() === doc
        );

        setSelectedRows(prev => [...prev, index]);

        setSelectAll(
            selectedDocketNos.length + 1 === getData.length
        );

        // Clear textbox for next scan
        setDocket("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (JSON.parse(localStorage.getItem("Login"))?.Branch_Code === "ALB") {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'You Can not generate runsheet,please login the branch',
            });
            return;
        }

        if (selectedDocketNos.length === 0) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Please select at least one Docket No before submitting the form.',
            });
            return;
        }

        const payload = {
            sessionLocationCode: JSON.parse(localStorage.getItem("Login"))?.Branch_Code,
            VehicleNo: formData.vehicleNo,
            employeeCode: formData.empName,
            Area: formData.cityName ? getCity.find((city) => city.City_Code === formData.cityName)?.City_Name : "",
            EmployeeMobile: String(formData.mobileNo),
            DocketNo: selectedDocketNos,
            DrsDate: formatDate(formData.drsDate),
        };
        console.log(payload);

        try {
            const response = await postApi('Runsheet/generateRunsheet', payload);
            console.log(response);
            if (response.status === 1) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Data has been successfully generated!',
                    timer: 2000,
                    showConfirmButton: true,
                });
                await fetchData();
                setFormData({
                    vehicleNo: "",
                    empName: "",
                    cityName: "",
                    mobileNo: "",
                    DocketNo: [],
                    drsDate: today
                });
                setSelectedManifestRows([]);
                setSelectedRows([]);
                setSelectedDocketNos([]);
            }

        } catch (error) {
            console.error("error submitting DRS:", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Something went wrong while generating data. Please try again.',
            });
        }
    }

    return (
        <>
            <div className="container1">

                <form onSubmit={handleSubmit} >
                    <div className="fields2">
                        <div className="input-field3" >
                            <label htmlFor="">Vehicle No</label>
                            <Select
                                options={vehicleData.map(vehicle => ({
                                    value: vehicle.vehicle_number,   // adjust keys from your API
                                    label: vehicle.vehicle_number
                                }))}
                                value={
                                    formData.vehicleNo
                                        ? { value: formData.vehicleNo, label: vehicleData.find(c => c.vehicle_number === formData.vehicleNo)?.vehicle_number || "" }
                                        : null
                                }
                                onChange={(selectedOption) =>
                                    setFormData({
                                        ...formData,
                                        vehicleNo: selectedOption ? selectedOption.value : ""
                                    })
                                }
                                placeholder="Vehicle Number"
                                isSearchable
                                classNamePrefix="blue-selectbooking"
                                className="blue-selectbooking"
                                menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                                styles={{
                                    placeholder: (base) => ({
                                        ...base,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis"
                                    }),
                                    menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                                }}
                            />
                        </div>

                        <div className="input-field3" >
                            <label htmlFor="">Employee Name</label>
                            <Select
                                options={
                                    empData.map(emp => ({
                                        value: emp.Employee_Code,   // adjust keys from your API
                                        label: emp.Employee_Name,
                                        mobileNo: emp.Employee_Mob,
                                    }))
                                }
                                value={
                                    formData.empName
                                        ? { value: formData.empName, label: empData.find(c => c.Employee_Code === formData.empName)?.Employee_Name || "" }
                                        : null
                                }
                                onChange={(selectedOption) =>
                                    setFormData({
                                        ...formData,
                                        empName: selectedOption ? selectedOption.value : "",
                                        mobileNo: selectedOption ? selectedOption.mobileNo : "",

                                    })
                                }
                                placeholder="Select Employee"
                                isSearchable
                                classNamePrefix="blue-selectbooking"
                                className="blue-selectbooking"
                                menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                                styles={{
                                    placeholder: (base) => ({
                                        ...base,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis"
                                    }),
                                    menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                                }}
                            />
                        </div>

                        <div className="input-field3" >
                            <label htmlFor="">Mobile No</label>
                            <input type="tel" maxLength={10} placeholder="Mobile No" className="input"
                                value={formData.mobileNo}
                                onChange={(e) => setFormData({ ...formData, mobileNo: e.target.value })} />
                        </div>

                        <div className="input-field3">
                            <label htmlFor="">Drs Date</label>
                            <DatePicker
                                selected={formData.drsDate}
                                onChange={(date) => handleDateChange(date, "drsDate")}
                                dateFormat="dd/MM/yyyy"
                                className="form-control form-control-sm"
                                portalId="root-portal"
                            />
                        </div>
                        <div className="input-field3" >
                            <label htmlFor="">City</label>
                            <Select
                                options={getCity.map(city => ({
                                    value: city.City_Code,   // adjust keys from your API
                                    label: city.City_Name
                                }))}
                                value={
                                    formData.cityName
                                        ? { value: formData.cityName, label: getCity.find(c => c.City_Code === formData.cityName)?.City_Name || "" }
                                        : null
                                }
                                onChange={(selectedOption) =>
                                    setFormData({
                                        ...formData,
                                        cityName: selectedOption ? selectedOption.value : ""
                                    })
                                }
                                placeholder="Select City"
                                isSearchable
                                classNamePrefix="blue-selectbooking"
                                className="blue-selectbooking"
                                menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                                styles={{
                                    placeholder: (base) => ({
                                        ...base,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis"
                                    }),
                                    menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                                }}
                            />

                        </div>

                        <div className="input-field3" >
                            <label htmlFor="">Docket No</label>
                            <div style={{ display: "flex", gap: "5px" }}>
                                    <input
                                        style={{ flex: 1 }}
                                className="input"
                                placeholder="Enter Docket No"
                                autoFocus
                                value={docket}
                                onChange={(e) =>
                                    setDocket(e.target.value)
                                }
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault(); // stop form submit
                                        handleFind();       // auto call after scan
                                    }
                                }}
                            />
                            <button type="button" className="ok-btn" style={{ width: "40px" }} onClick={handleFind}>Find</button>
                            </div>
                        </div>

                        <div className="bottom-buttons" style={{ marginTop: "23px", marginLeft:"10px"}}>
                            
                            <button type="submit" className="ok-btn" >Generate</button>
                                <button type="button" className="ok-btn"  onClick={() => setFormData({
                                    vehicleNo: "",
                                    empName: "",
                                    cityName: "",
                                    mobileNo: "",
                                    DocketNo: [],
                                    drsDate: today
                                })}>Reset</button>
                                
                        </div>



                        <div className="input-field3" >
                            <label htmlFor="" style={{ whiteSpace: "nowrap" }}>Bulk Runsheet</label>
                            <button type="button" className="ok-btn" style={{ height: "35px", width: "100%", fontSize: "14px", lineHeight: "1" }}
                                onClick={() => { setModalIsOpen(true) }}>Bulk Runsheet</button>
                        </div>

                        

                        
                    </div>
                </form >

                <div className='table-container'>
                    <table className='table table-bordered table-sm'>
                        <thead className='table-sm'>
                            <tr>
                                <th scope="col" className="w-60">Sr.No</th>
                                <th scope="col">Docket.No</th>
                                <th scope="col">Booking.Date</th>
                                <th scope="col">Manifest.No</th>
                                <th scope="col">Customer.Name</th>
                                <th scope="col">Consignee.Name</th>
                                <th scope="col">From</th>
                                <th scope="col">To</th>
                                <th scope="col">Qty</th>
                                <th scope="col">Act.Weight</th>
                                <th scope="col">Total.Amount</th>
                                <th scope="col">Status</th>
                            </tr>
                        </thead>
                        <tbody className='table-body'>
                            {selectedManifestRows.map((runsheet, index) => (
                                <tr key={index} >
                                    <td className="w-60">{index + 1}</td>
                                    <td>{runsheet.DocketNo}</td>
                                    <td>{runsheet.Bookdate}</td>
                                    <td>{runsheet.ManifestNo}</td>
                                    <td>{runsheet.customerName}</td>
                                    <td>{runsheet.consigneeName}</td>
                                    <td>{runsheet.OriginName}</td>
                                    <td>{runsheet.DestinationName}</td>
                                    <td>{runsheet.Qty}</td>
                                    <td>{runsheet.ActualWt}</td>
                                    <td>{runsheet.totalAmt}</td>
                                    <td>{runsheet.Status}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>


                <Modal
                    overlayClassName="custom-overlay"
                    isOpen={modalIsOpen}
                    className="custom-modal"
                    contentLabel="Modal"
                    style={{
                        content: {
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',

                            overflowY: 'auto',     // ✅ enable vertical scroll
                            overflowX: 'auto',   // optional (clean UI)
                            zIndex: "999999999",
                        },
                    }}
                >
                    <div className="custom-modal-content">
                        <div className="header-tittle" style={{ display: "flex", flexDirection: "row" }}>
                            <header style={{ width: "95%", textAlign: "center" }}>Pending Runsheet Data</header>
                            <button className="ok-btn" style={{ width: "60px", height: "100%", backgroundColor: "red" }}
                                onClick={() => setModalIsOpen(false)}>
                                <i className="bi bi-x-lg"></i>
                            </button>
                        </div>
                        <div className='container2' style={{ borderRadius: "0px", padding: "10px" }}>

                            <div className="addNew" style={{ whiteSpace: "nowrap" }}>


                                <div className="search-input">
                                    <input
                                        className="add-input1"
                                        type="text"
                                        placeholder="search"
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                        style={{ marginLeft: "0%" }}
                                    />
                                    <button type="submit" title="search">
                                        <i className="bi bi-search"></i>
                                    </button>
                                </div>


                                <div className="custom-field">
                                    <div className="custom-date input-field">
                                        <label >From Date</label>
                                        <DatePicker
                                            portalId="root-portal"
                                            selected={fromDateM}
                                            onChange={(date) => setFromDateM(date)}
                                            dateFormat="dd/MM/yyyy"

                                        />
                                    </div>

                                    <div className="custom-date input-field" >
                                        <label >To Date</label>
                                        <DatePicker
                                            portalId="root-portal"
                                            selected={toDateM}
                                            onChange={(date) => setToDateM(date)}
                                            dateFormat="dd/MM/yyyy"

                                        />
                                    </div>

                                </div>



                                <div className="bottom-buttons">
                                    <button style={{ marginTop: "5px" }} className="ok-btn" onClick={handleDocketNoSelect}>Submit</button>
                                </div>

                            </div>
                            <div className='table-container'>
                                <table className='table table-bordered table-sm'>
                                    <thead className='table-sm'>
                                        <tr>
                                            <th scope="col" className="w-60">
                                                <input type="checkbox" 
                                                    checked={selectAll} onChange={handleSelectAll} />
                                            </th>
                                            <th scope="col" className="w-60">Sr.No</th>
                                            <th scope="col">Docket.No</th>
                                            <th scope="col">Booking.Date</th>
                                            <th scope="col">Manifest.No</th>
                                            <th scope="col">Customer.Name</th>
                                            <th scope="col">Consignee.Name</th>
                                            <th scope="col">From</th>
                                            <th scope="col">To</th>
                                            <th scope="col">Qty</th>
                                            <th scope="col">Act.Weight</th>
                                            <th scope="col">Total.Amount</th>
                                            <th scope="col">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody className='table-body'>
                                        {getData.map((runsheet, index) => (
                                            <tr key={index} >
                                                <td scope="col" className="w-60">
                                                    <input type="checkbox"
                                                        checked={selectedRows.includes(index)}
                                                        onChange={() => handleRowSelect(index, runsheet.DocketNo, getData.length)} />
                                                </td>
                                                <td className="w-60">{index + 1}</td>
                                                <td>{runsheet.DocketNo}</td>
                                                <td>{runsheet.Bookdate}</td>
                                                <td>{runsheet.ManifestNo}</td>
                                                <td>{runsheet.customerName}</td>
                                                <td>{runsheet.consigneeName}</td>
                                                <td>{runsheet.OriginName}</td>
                                                <td>{runsheet.DestinationName}</td>
                                                <td>{runsheet.Qty}</td>
                                                <td>{runsheet.ActualWt}</td>
                                                <td>{runsheet.totalAmt}</td>
                                                <td>{runsheet.Status}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="row" style={{ whiteSpace: "nowrap" }}>
            <div className="pagination col-12 col-md-6 d-flex justify-content-center align-items-center mb-2 mb-md-0">
              <button className="ok-btn" onClick={handlePreviousPage} disabled={currentPage === 1}>
                {'<'}
              </button>
              <span style={{ color: "#333", padding: "5px" }}>
                Page {currentPage} of {totalPages}
              </span>
              <button className="ok-btn" onClick={handleNextPage} disabled={currentPage === totalPages}>
                {'>'}
              </button>
            </div>

            <div className="rows-per-page col-12 col-md-6 d-flex justify-content-center justify-content-md-end align-items-center">
              <span htmlFor="rowsPerPage" className="me-2">Rows per page: </span>
              <select
                id="rowsPerPage"
                value={rowsPerPage}
                onChange={(e) => {
                  setRowsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}

                style={{ height: "40px", width: "50px", border: "1.5px solid #002357" }}
              >
                <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={200}>200</option>
                            <option value={500}>500</option>
              </select>
            </div>
          </div>
                        </div>
                    </div>
                </Modal >
            </div >

        </>
    );
};

export default CreateDrs;